module.exports = __webpack_public_path__ + "03_long_black.6db73790.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_long_black.png
// module id = /tsN
// module chunks = 0